import { Capacitor } from '@capacitor/core';

/** Native APK: Capacitor reload. PWA/web: full navigation (web App.reload stub throws). */
export async function reloadApp(fallbackPath = '/login'): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    globalThis.location.reload();
    return;
  }
  globalThis.location.replace(`${globalThis.location.origin}${fallbackPath}`);
}
